module.exports = __webpack_public_path__ + "img/video08.8a6d50c2.jpeg";